// Pure helpers for the superadmin pickers (kept out of the components so they can be unit-tested).

import type { OrgOption, UserOption } from '@/apis/adminApi'

export function orgPrimary(o: OrgOption): string {
    return o.name || o.slug
}

/** "owner@x.com · payg · Storefront (shop.example.com) +2 · …1a2b3c4d" */
export function orgSecondary(o: OrgOption): string {
    const parts: string[] = []
    parts.push(o.owners.length ? o.owners.join(', ') : 'no members')
    parts.push(o.plan)
    if (o.status !== 'active') {
        parts.push(o.status)
    }
    if (o.projects.length) {
        const [first, ...rest] = o.projects
        parts.push(
            `${first.name}${first.domain ? ` (${first.domain})` : ''}${rest.length ? ` +${rest.length}` : ''}`,
        )
    }
    parts.push(o.shortId)
    return parts.join(' · ')
}

export function userPrimary(u: UserOption): string {
    return u.name ? `${u.name} <${u.email}>` : u.email
}

export function userSecondary(u: UserOption): string {
    const orgs = u.orgs.map(o => `${o.name} (${o.role})`)
    return [orgs.length ? orgs.join(', ') : 'no org', u.shortId].join(' · ')
}

/** Client-side filter over the server results (the server already searches; this keeps typing snappy). */
export function matchesOrg(o: OrgOption, q: string): boolean {
    const t = q.trim().toLowerCase()
    if (!t) {
        return true
    }
    const hay = [
        o.name,
        o.slug,
        o.id,
        o.plan,
        ...o.owners,
        ...o.projects.flatMap(p => [p.name, p.domain, p.id]),
    ]
        .join(' ')
        .toLowerCase()
    return hay.includes(t)
}

export function matchesUser(u: UserOption, q: string): boolean {
    const t = q.trim().toLowerCase()
    if (!t) {
        return true
    }
    return [u.name, u.email, u.id, ...u.orgs.map(o => o.name)].join(' ').toLowerCase().includes(t)
}
